<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
        size="small"
        v-if="$canEdit"
        >添加
      </el-button>
      <el-input
        v-model="listQuery.username"
        placeholder="客户账号"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.name"
        placeholder="客户名称"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 90px"
        class="filter-item"
        size="small"
      >
        <el-option label="正常" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-select
        v-model="listQuery.client_category"
        placeholder="客户分类"
        clearable
        style="width: 130px"
        class="filter-item"
        size="small"
      >
        <el-option label="商旅" value="business" />
        <el-option label="OTA" value="otc" />
      </el-select>
      <el-select
        v-model="listQuery.is_open_company"
        placeholder="成员公司模式"
        clearable
        style="width: 130px"
        class="filter-item"
        size="small"
      >
        <el-option label="开放" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-select
        v-model="listQuery.is_self_use"
        placeholder="合作商自用模式"
        clearable
        style="width: 140px"
        class="filter-item"
        size="small"
      >
        <el-option label="开放" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-select
        v-model="listQuery.cooperation_type"
        placeholder="合作类型"
        clearable
        style="width: 120px"
        class="filter-item"
        size="small"
      >
        <el-option label="账期合作" value="account_term" />
        <el-option label="预充值合作" value="advance_recharge" />
        <el-option label="企业现付" value="enterprise_cash_payment" />
      </el-select>
      <el-select
        v-model="listQuery.account_term_cycle"
        placeholder="账期周期"
        clearable
        style="width: 120px"
        class="filter-item"
        size="small"
      >
        <el-option label="周结" value="weekly_settlement" />
        <el-option label="半月结" value="half_month_settlement" />
        <el-option label="月结" value="monthly_settlement" />
      </el-select>

      <el-select
        v-model="listQuery.api_account_name"
        placeholder="锦江卡"
        filterable
        clearable
        style="width: 160px"
        class="filter-item"
        size="small"
      >
        <el-option
          v-for="item in apiAccountList"
          :key="item.name"
          :label="item.name"
          :value="item.name"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <!-- 展开行：收纳低频信息（原主表 12 列），减列后一屏可视 -->
      <el-table-column type="expand" width="34">
        <template slot-scope="props">
          <div class="expand-detail">
            <div class="expand-item">
              <span class="expand-label">客户全称</span>
              <span class="expand-value">{{ props.row.full_name || '-' }}</span>
            </div>
            <div class="expand-item">
              <span class="expand-label">App ID</span>
              <span class="expand-value">
                <template v-if="visibleSecrets[props.$index]">{{
                  props.row.app_id
                }}</template>
                <el-button
                  v-else
                  type="text"
                  size="mini"
                  @click="openPasswordPrompt(props.$index, props.row)"
                  >点击查看</el-button
                >
              </span>
            </div>
            <div class="expand-item">
              <span class="expand-label">App Secret</span>
              <span class="expand-value">
                <template v-if="visibleSecrets[props.$index]">{{
                  props.row.app_secret
                }}</template>
                <el-button
                  v-else
                  type="text"
                  size="mini"
                  @click="openPasswordPrompt(props.$index, props.row)"
                  >点击查看</el-button
                >
              </span>
            </div>
            <div class="expand-item">
              <span class="expand-label">IP白名单</span>
              <span class="expand-value">{{ props.row.ips || '-' }}</span>
            </div>
            <div class="expand-item">
              <span class="expand-label">QPS</span>
              <span class="expand-value">{{ props.row.qps || '-' }}</span>
            </div>
            <div class="expand-item">
              <span class="expand-label">上级渠道名称</span>
              <span class="expand-value">{{
                props.row.channel ? props.row.channel.name : '-'
              }}</span>
            </div>
            <div class="expand-item">
              <span class="expand-label">上级佣金比率(%)</span>
              <span class="expand-value">{{
                props.row.channel_commission_rate
                  ? props.row.channel_commission_rate * 100
                  : '-'
              }}</span>
            </div>
            <div class="expand-item">
              <span class="expand-label">成员公司模式</span>
              <span class="expand-value">
                <el-tag
                  v-if="props.row.is_open_company == 1"
                  type="success"
                  size="mini"
                  >开放</el-tag
                >
                <el-tag v-else type="warning" size="mini">禁用</el-tag>
              </span>
            </div>
            <div class="expand-item">
              <span class="expand-label">合作商自用模式</span>
              <span class="expand-value">
                <el-tag
                  v-if="props.row.is_self_use == 1"
                  type="success"
                  size="mini"
                  >开放</el-tag
                >
                <el-tag v-else type="warning" size="mini">禁用</el-tag>
              </span>
            </div>
            <div class="expand-item">
              <span class="expand-label">预订规则校验</span>
              <span class="expand-value">
                <el-tag
                  v-if="isRuleVerifyEnabled(props.row.book_rule_verify_enabled)"
                  type="success"
                  size="mini"
                  >开启校验</el-tag
                >
                <el-tag v-else type="info" size="mini">跳过校验</el-tag>
              </span>
            </div>
            <div class="expand-item">
              <span class="expand-label">取消规则校验</span>
              <span class="expand-value">
                <el-tag
                  v-if="
                    isRuleVerifyEnabled(props.row.cancel_rule_verify_enabled)
                  "
                  type="success"
                  size="mini"
                  >开启校验</el-tag
                >
                <el-tag v-else type="info" size="mini">跳过校验</el-tag>
              </span>
            </div>
            <div class="expand-item">
              <span class="expand-label">客户分类</span>
              <span class="expand-value">{{
                props.row.client_category == 'business' ? '商旅' : 'OTA'
              }}</span>
            </div>
            <div class="expand-item">
              <span class="expand-label">是否显示成本</span>
              <span class="expand-value">
                <el-switch
                  :value="props.row.is_show_cost == 1"
                  @change="handleChangeShowCost(props.row)"
                />
              </span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="ID" min-width="52">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="客户账号" min-width="86" align="center">
        <template slot-scope="scope">
          {{ scope.row.username }}
        </template>
      </el-table-column>
      <el-table-column label="客户名称" min-width="92" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="合作类型" min-width="84" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.cooperation_type === 'account_term'"
            type="primary"
            >账期合作</el-tag
          >
          <el-tag
            v-else-if="scope.row.cooperation_type === 'advance_recharge'"
            type="success"
            >预充值合作</el-tag
          >
          <el-tag
            v-else-if="scope.row.cooperation_type === 'enterprise_cash_payment'"
            type="info"
            >企业现付</el-tag
          >
          <el-tag v-else type="warning">-</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="账期周期" min-width="84" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.account_term_cycle === 'weekly_settlement'"
            type="primary"
            >周结</el-tag
          >
          <el-tag
            v-else-if="scope.row.account_term_cycle === 'half_month_settlement'"
            type="success"
            >半月结</el-tag
          >
          <el-tag
            v-else-if="scope.row.account_term_cycle === 'monthly_settlement'"
            type="warning"
            >月结</el-tag
          >
          <el-tag v-else type="warning">-</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="92" align="center">
        <template slot-scope="scope">
          {{ scope.row.contact_phone }}
        </template>
      </el-table-column>
      <el-table-column label="联系邮箱" min-width="104" align="center">
        <template slot-scope="scope">
          <el-tag
            v-for="(email, index) in (scope.row.contact_email || '')
              .split(',')
              .filter(Boolean)"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ email.trim() }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        min-width="68"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal == 1" type="success">正常</el-tag>
          <el-tag v-else type="warning">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="渠道ID" min-width="74" align="center">
        <template slot-scope="scope">
          {{ scope.row.channel_id || '-' }}
        </template>
      </el-table-column>
      <!--      <el-table-column label="渠道代理加价比率(%)" min-width="96" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.channel_price_rate * 100 || "-" }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="房源权限" min-width="112" align="center">
        <template slot-scope="scope">
          <el-tooltip
            placement="top"
            :disabled="
              permList(scope.row).length <= 2
            "
          >
            <div slot="content" style="max-width: 320px; line-height: 1.7">
              <div
                v-for="(t, i) in permList(scope.row)"
                :key="i"
              >
                {{ t }}
              </div>
            </div>
            <div class="cell-tags">
              <el-tag
                v-for="(t, i) in permList(scope.row).slice(0, 2)"
                :key="i"
                type="success"
                effect="plain"
                size="mini"
              >
                {{ t }}
              </el-tag>
              <el-tag
                v-if="permList(scope.row).length > 2"
                type="info"
                effect="plain"
                size="mini"
                >+{{ permList(scope.row).length - 2 }}</el-tag
              >
              <span v-if="!permList(scope.row).length">-</span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="锦江卡" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tooltip
            placement="top"
            :disabled="(scope.row.bind_api_accounts_show || []).length <= 2"
          >
            <div slot="content" style="max-width: 340px; line-height: 1.7">
              <div
                v-for="(item, i) in scope.row.bind_api_accounts_show || []"
                :key="i"
              >
                {{ item.name
                }}{{
                  item.deleted_at || item.status != 'enable'
                    ? '（已停用）'
                    : ''
                }}
              </div>
            </div>
            <div class="cell-tags">
              <el-tag
                v-for="(item, index) in (
                  scope.row.bind_api_accounts_show || []
                ).slice(0, 2)"
                :key="index"
                :type="
                  item.deleted_at || item.status != 'enable'
                    ? 'danger'
                    : 'success'
                "
                effect="plain"
                size="mini"
              >
                {{ item.name }}
              </el-tag>
              <el-tag
                v-if="(scope.row.bind_api_accounts_show || []).length > 2"
                type="info"
                effect="plain"
                size="mini"
                >+{{ scope.row.bind_api_accounts_show.length - 2 }}</el-tag
              >
              <span v-if="!(scope.row.bind_api_accounts_show || []).length"
                >-</span
              >
            </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column label="丽呈卡" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tooltip
            placement="top"
            :disabled="(scope.row.bind_api_cards_show || []).length <= 2"
          >
            <div slot="content" style="max-width: 340px; line-height: 1.7">
              <div
                v-for="(item, i) in scope.row.bind_api_cards_show || []"
                :key="i"
              >
                {{ cardDisplayName(item)
                }}{{
                  item.deleted_at || item.status != 'enable'
                    ? '（已停用）'
                    : ''
                }}
              </div>
            </div>
            <div class="cell-tags">
              <el-tag
                v-for="(item, index) in (
                  scope.row.bind_api_cards_show || []
                ).slice(0, 2)"
                :key="index"
                :type="
                  item.deleted_at || item.status != 'enable'
                    ? 'danger'
                    : 'success'
                "
                effect="plain"
                size="mini"
              >
                {{ cardDisplayName(item) }}
              </el-tag>
              <el-tag
                v-if="(scope.row.bind_api_cards_show || []).length > 2"
                type="info"
                effect="plain"
                size="mini"
                >+{{ scope.row.bind_api_cards_show.length - 2 }}</el-tag
              >
              <span v-if="!(scope.row.bind_api_cards_show || []).length"
                >-</span
              >
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="96"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        min-width="200"
        v-if="$canEdit"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <!-- 横排一行：修改 / 卡管理 / 更多（低频项收进下拉，压缩行高） -->
          <div class="ops-flex">
            <el-button
              size="mini"
              type="primary"
              @click="handleUpdate(scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="openCardDialog(scope.row)"
              >卡管理</el-button
            >
            <el-dropdown
              trigger="click"
              size="mini"
              @command="(c) => handleMoreCommand(c, scope.row)"
            >
              <el-button size="mini">
                更多<i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="scope.row.is_normal == 1"
                  command="disable"
                  >禁用</el-dropdown-item
                >
                <el-dropdown-item v-else command="enable"
                  >解禁</el-dropdown-item
                >
                <el-dropdown-item command="commonInfo"
                  >常用信息修改</el-dropdown-item
                >
                <el-dropdown-item command="initPassword"
                  >初始化密码</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        size="small"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="130px"
        style="margin-left: 50px"
      >
        <el-form-item label="客户账号" prop="username">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item label="客户名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="客户全称" prop="full_name">
          <el-input v-model="form.full_name" />
        </el-form-item>
        <el-form-item label="合作类型" prop="cooperation_type">
          <el-select v-model="form.cooperation_type">
            <el-option label="账期合作" :value="'account_term'" />
            <el-option label="预充值合作" :value="'advance_recharge'" />
            <el-option label="企业现付" :value="'enterprise_cash_payment'" />
          </el-select>
        </el-form-item>
        <el-form-item label="账期周期" prop="account_term_cycle">
          <el-select v-model="form.account_term_cycle">
            <el-option label="周结" value="weekly_settlement" />
            <el-option label="半月结" value="half_month_settlement" />
            <el-option label="月结" value="monthly_settlement" />
          </el-select>
        </el-form-item>
        <el-form-item label="客户分类" prop="client_category">
          <el-select v-model="form.client_category">
            <el-option label="商旅" value="business" />
            <el-option label="OTA" value="otc" />
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话" prop="contact_phone">
          <el-input v-model="form.contact_phone" />
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contact_email">
          <el-input
            v-model="form.contact_email"
            placeholder="多个邮箱请用逗号隔开"
          />
        </el-form-item>
        <el-form-item label="上级渠道ID" prop="channel_id">
          <el-input
            v-model="form.channel_id"
            @input="getChannelData(form.channel_id)"
          />
        </el-form-item>
        <el-form-item label="渠道名称" prop="">
          {{ channel.name || '无渠道' }}
        </el-form-item>
        <el-form-item label="渠道佣金比率(%)" prop="channel_commission_rate">
          <el-input-number v-model="form.channel_commission_rate" />
        </el-form-item>
        <el-form-item label="IP白名单" prop="ips">
          <el-input v-model="form.ips" />
        </el-form-item>
        <el-form-item label="QPS" prop="qps">
          <el-input v-model="form.qps" />
        </el-form-item>
        <el-form-item label="状态" prop="is_normal">
          <el-select v-model="form.is_normal">
            <el-option label="正常" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="渠道加价比率(%)" prop="channel_price_rate">-->
        <!--          <el-input-number v-model="form.channel_price_rate"/>-->
        <!--        </el-form-item>-->
        <el-form-item label="绑定锦江账户" prop="bind_api_accounts">
          <el-select
            v-model="form.bind_api_accounts"
            multiple
            placeholder="请选择锦江账户"
            style="width: 100%"
          >
            <el-option
              :style="item.disabled && 'background-color: #F56C6C;color:white;'"
              v-for="(item, index) in fliterApiAccountList(
                form.bind_api_accounts,
              )"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="绑定丽呈卡号" prop="bind_api_cards">
          <el-select
            v-model="form.bind_api_cards"
            multiple
            placeholder="不选则从状态正常的丽呈卡中随机使用"
            style="width: 100%"
          >
            <el-option
              :style="item.disabled && 'background-color: #F56C6C;color:white;'"
              v-for="(item, index) in filterLiChengCards(form.bind_api_cards)"
              :key="index"
              :label="cardLabel(item)"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房源权限" prop="hotel_permissions">
          <div
            v-for="(item, index) in form.hotel_permissions"
            :key="index"
            style="display: flex; align-items: center; margin-bottom: 10px"
          >
            <el-checkbox
              v-model="item.is_enabled"
              :true-label="1"
              :false-label="0"
            >
              {{ getTargetTypeName(item.hotel_permissions_type) + '房源' }}
            </el-checkbox>
            <span style="margin-left: 12px">渠道佣金比率(%):</span>
            <el-input-number
              v-model="item.channel_price_rate"
              :min="0"
              style="margin-left: 10px; flex: 1"
              placeholder="渠道加价比率"
            />
          </div>
        </el-form-item>
        <el-form-item label="成员公司模式" prop="is_open_company">
          <el-switch
            v-model="form.is_open_company"
            active-text="开放"
            inactive-text="禁用"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="合作商自用模式" prop="is_self_use">
          <el-switch
            v-model="form.is_self_use"
            active-text="开放"
            inactive-text="禁用"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="预订规则校验" prop="book_rule_verify_enabled">
          <el-switch
            v-model="form.book_rule_verify_enabled"
            active-text="开启校验"
            inactive-text="跳过校验"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item label="取消规则校验" prop="cancel_rule_verify_enabled">
          <el-switch
            v-model="form.cancel_rule_verify_enabled"
            active-text="开启校验"
            inactive-text="跳过校验"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="常用信息修改"
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        ref="form1"
        :rules="rules1"
        :model="form1"
        label-position="left"
        label-width="150px"
        style="margin-left: 50px"
      >
        <el-form-item label="购买方名称" prop="buyer_name">
          <el-input v-model="form1.buyer_name" />
        </el-form-item>
        <el-form-item label="购买方纳税人识别号" prop="buyer_taxpayer_no">
          <el-input v-model="form1.buyer_taxpayer_no" />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form1.address" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form1.phone" />
        </el-form-item>
        <el-form-item label="开户行" prop="bank">
          <el-input v-model="form1.bank" />
        </el-form-item>
        <el-form-item label="银行卡号" prop="bank">
          <el-input v-model="form1.bank_no" />
        </el-form-item>
        <el-form-item label="纳税人资质" prop="taxpayer_qualification_type">
          <el-select v-model="form1.taxpayer_qualification_type">
            <el-option label="小微企业" :value="1" />
            <el-option label="一般纳税人" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="开票类型" prop="invoicing_type">
          <el-select v-model="form1.invoicing_type">
            <el-option label="普通发票" :value="1" />
            <el-option label="专用发票" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="发送邮箱" prop="email">
          <el-input v-model="form1.email" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form1.remark" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
        <el-button type="primary" @click="saveData1" :loading="btnLoading1"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="请输入操作密码"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form2"
        :rules="rules2"
        :model="form2"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="操作密码" prop="password">
          <el-input v-model="form2.password" type="password" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="confirmPassword">确定</el-button>
      </span>
    </el-dialog>

    <!-- 卡管理：统一维护绑定锦江账户 / 绑定丽呈卡号 / 房源权限+加价 -->
    <el-dialog
      title="卡管理"
      :visible.sync="cardDialogVisible"
      :close-on-click-modal="false"
      width="640px"
    >
      <div v-if="cardDialogRow" class="card-manage">
        <div class="card-manage__target">
          客户：<b>{{ cardDialogRow.name }}</b>
          <span class="card-manage__tip"
            >（此处维护卡绑定与房源加价，与「修改」弹窗中的同名项联动）</span
          >
        </div>

        <el-form label-position="left" label-width="130px">
          <el-form-item label="绑定锦江账户" prop="bind_api_accounts">
            <el-select
              v-model="cardForm.bind_api_accounts"
              multiple
              placeholder="请选择锦江账户"
              style="width: 100%"
            >
              <el-option
                :style="
                  item.disabled && 'background-color: #F56C6C;color:white;'
                "
                v-for="(item, index) in fliterApiAccountList(
                  cardForm.bind_api_accounts,
                )"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="绑定丽呈卡号" prop="bind_api_cards">
            <el-select
              v-model="cardForm.bind_api_cards"
              multiple
              placeholder="不选则从状态正常的丽呈卡中随机使用"
              style="width: 100%"
            >
              <el-option
                :style="
                  item.disabled && 'background-color: #F56C6C;color:white;'
                "
                v-for="(item, index) in filterLiChengCards(
                  cardForm.bind_api_cards,
                )"
                :key="index"
                :label="cardLabel(item)"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <div class="card-manage__hint">
              说明：丽呈下单始终按<strong>房态价格折扣匹配同折扣卡</strong>（如 82
              折房态只能用 82 折卡）。<br />
              <span class="card-manage__warn"
                >⚠ 一张都不绑时，下单会从库中随机选取「状态正常且折扣匹配」的卡
                ——并不会因此不走丽呈；若库中恰好没有该折扣的卡，该笔订单会下单失败。</span
              >
            </div>
          </el-form-item>

          <el-form-item label="房源权限" prop="hotel_permissions">
            <div
              v-for="(item, index) in cardForm.hotel_permissions"
              :key="index"
              class="card-manage__perm"
            >
              <el-checkbox
                v-model="item.is_enabled"
                :true-label="1"
                :false-label="0"
              >
                {{ getTargetTypeName(item.hotel_permissions_type) + '房源' }}
              </el-checkbox>
              <span class="card-manage__perm-label">渠道佣金比率(%):</span>
              <el-input-number
                v-model="item.channel_price_rate"
                :min="0"
                style="flex: 1"
                placeholder="渠道加价比率"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cardDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="cardSaving" @click="saveCardDialog"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import uploadList from '@/components/UploadList/index.vue'
import { getTargetTypeName } from '@/utils/targetType'

export default {
  components: { uploadList },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: '',
        bind_api_account_id: '',
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      channel: { name: '' },
      form: {
        id: '',
        name: undefined,
        full_name: undefined,
        contact_phone: undefined,
        contact_email: undefined,
        channel_id: undefined,
        channel_commission_rate: undefined,
        is_normal: 1,
        ips: undefined,
        channel_price_rate: 0,
        bind_api_accounts: [],
        hotel_permissions: [
          {
            hotel_permissions_type: 'jin_jiang',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'long_teng',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'sui_chuan',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'li_cheng',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'ya_si_te',
            channel_price_rate: 0,
            is_enabled: 0,
          },
        ],
        is_open_company: 0,
        is_self_use: 0,
        book_rule_verify_enabled: 1,
        cancel_rule_verify_enabled: 1,
      },
      rules: {
        username: [
          { required: true, message: '客户账号不能为空', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '客户名称不能为空', trigger: 'blur' },
        ],
        full_name: [
          { required: true, message: '客户全称不能为空', trigger: 'blur' },
        ],
        contact_phone: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
        ],
        contact_email: [
          { required: true, message: '联系邮箱不能为空', trigger: 'blur' },
        ],
        is_normal: [
          { required: true, message: '状态不能为空', trigger: 'blur' },
        ],
        qps: [{ required: true, message: 'QPS不能为空', trigger: 'blur' }],
        hotel_permissions: [
          {
            validator: (_rule, value, callback) => {
              if (value && value.length) {
                const emptyIndex = value.findIndex(
                  (item) =>
                    item.channel_price_rate === null ||
                    item.channel_price_rate === undefined,
                )
                if (emptyIndex !== -1) {
                  callback(
                    new Error(
                      `${
                        getTargetTypeName(
                          value[emptyIndex].hotel_permissions_type,
                        ) + '房源'
                      }的渠道佣金比率不能为空`,
                    ),
                  )
                }
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
      },
      btnLoading: false,
      dialogFormVisible1: false,
      dialogStatus1: '',
      textMap1: {
        update: '编辑',
        create: '添加',
      },
      form1: {
        app_client_id: '',
        buyer_name: undefined,
        buyer_taxpayer_no: undefined,
        address: undefined,
        phone: undefined,
        bank: undefined,
        bank_no: undefined,
        taxpayer_qualification_type: undefined,
        invoicing_type: undefined,
        email: undefined,
        remark: undefined,
      },
      rules1: {
        buyer_name: [
          { required: true, message: '购买方名称不能为空', trigger: 'blur' },
        ],
        buyer_taxpayer_no: [
          {
            required: true,
            message: '购买方纳税人识别号不能为空',
            trigger: 'blur',
          },
        ],
      },
      btnLoading1: false,
      dialogVisible2: false,
      form2: {
        id: '',
        password: undefined,
      },
      rules2: {
        password: [
          { required: true, message: '操作密码不能为空', trigger: 'blur' },
        ],
      },
      currentRow: null,
      currentIndex: null,
      visibleSecrets: [],
      apiAccountList: [],
      // 丽呈卡列表（绑定丽呈卡号用）
      liChengCardList: [],
      // ===== 卡管理弹窗 =====
      cardDialogVisible: false,
      cardDialogRow: null,
      cardSaving: false,
      cardForm: {
        bind_api_accounts: [],
        bind_api_cards: [],
        // 房源权限：channel_price_rate 在此处为「百分数」（提交时 /100）
        hotel_permissions: [],
      },
      currentBindClientId: null,
    }
  },
  created() {
    this.getApiAccountList()
    this.getLiChengCardList()
    this.getList()
  },
  computed: {
    fliterApiAccountList() {
      return (bind_api_accounts) => {
        return this.apiAccountList.filter((item) => {
          // 如果item.id在bind_api_accounts中，则返回true（即使被禁用）
          if (bind_api_accounts && bind_api_accounts.includes(item.id)) {
            return true
          }
          // 否则检查是否被禁用
          return !(item.deleted_at || item.status == 'disable')
        })
      }
    },
    /**
     * 丽呈卡筛选：已选中的即使被禁用也要保留（否则无法取消选择）
     * 规则与 fliterApiAccountList 保持一致
     */
    filterLiChengCards() {
      return (bind_api_cards) => {
        return this.liChengCardList.filter((item) => {
          if (bind_api_cards && bind_api_cards.includes(item.id)) {
            return true
          }
          return !(item.deleted_at || item.status == 'disable')
        })
      }
    },
  },
  methods: {
    /** 房源权限文案列表（已启用项），供列表单行折叠使用 */
    permList(row) {
      if (!row || !Array.isArray(row.hotel_permissions)) return []
      return row.hotel_permissions
        .filter((p) => p && p.is_enabled === 1)
        .map((p) => {
          let t = this.getTargetTypeName(p.hotel_permissions_type) + '房源'
          if (p.channel_price_rate) {
            t += ' | ' + p.channel_price_rate * 100 + '%'
          }
          return t
        })
    },
    /**
     * 丽呈卡展示名：优先取卡的公司名称（name）
     * 兼容卡号场景：name 缺失时退回卡号，再退回 ID
     */
    cardDisplayName(item) {
      if (!item) return ''
      return item.name || this.pickCardNo(item) || 'ID:' + item.id
    },
    getTargetTypeName: getTargetTypeName,
    isRuleVerifyEnabled(value) {
      return Number(value) !== 0
    },
    openPasswordPrompt(index, row) {
      this.currentRow = row
      this.currentIndex = index
      this.form2.id = row.id
      this.dialogVisible2 = true
    },
    confirmPassword() {
      request({
        url: '/api/backend/app-client/get-secret',
        method: 'get',
        params: this.form2,
      }).then((response) => {
        this.$set(this.visibleSecrets, this.currentIndex, true)
        this.list[this.currentIndex].app_id = response.data.app_id
        this.list[this.currentIndex].app_secret = response.data.app_secret
        this.dialogVisible2 = false
      })
    },
    getChannelData(id) {
      this.channel.name = null
      request({
        url: '/api/backend/channel/detail',
        method: 'get',
        params: {
          id,
        },
      }).then((response) => {
        if (response.data) {
          this.channel = response.data
        }
      })
    },

    getApiAccountList() {
      this.channel.name = null
      request({
        url: '/api/backend/api-account/list',
        method: 'get',
        params: {
          limit: 9999999999,
          api_type: 'jin_jiang',
          is_show_delete: 1,
        },
      }).then((response) => {
        if (response.data) {
          this.apiAccountList = response.data.data.map((item) => {
            return {
              ...item,
              disabled:
                item.deleted_at || item.status != 'enable' ? true : false,
            }
          })
        }
      })
    },
    /**
     * 加载丽呈卡列表（用于「绑定丽呈卡号」下拉）
     * 需求：一个渠道可绑多张卡；不绑则后端从状态正常的卡中随机使用
     */
    getLiChengCardList() {
      request({
        url: '/api/backend/li-cheng-card/list',
        method: 'get',
        params: {
          limit: 9999999999,
          api_type: 'li_cheng',
          is_show_delete: 1,
        },
      }).then((response) => {
        if (response.data) {
          this.liChengCardList = (response.data.data || []).map((item) => {
            return {
              ...item,
              disabled:
                item.deleted_at || item.status != 'enable' ? true : false,
            }
          })
        }
      })
    },
    /**
     * 读取丽呈卡号：字段名后端尚未定稿，按别名依次兼容
     * 定稿后建议只保留实际字段名
     */
    pickCardNo(row) {
      if (!row) return ''
      const keys = [
        'card_no',
        'card_number',
        'cardNo',
        'card_id',
        'card_code',
        'no',
      ]
      for (const k of keys) {
        const v = row[k]
        if (v !== undefined && v !== null && v !== '') return v
      }
      return ''
    },
    /** 下拉选项文案：卡号（名称）；卡号缺失时退回名称 */
    cardLabel(item) {
      if (!item) return ''
      const no = this.pickCardNo(item)
      const name = item.name || ''
      if (no && name) return no + '（' + name + '）'
      return no || name || 'ID:' + item.id
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        name: undefined,
        is_normal: 1,
        ips: undefined,
        channel_price_rate: 0,
        bind_api_cards: [],
      }
      this.btnLoading = false
    },
    handleCreate() {
      this.resetForm()
      this.form = {
        ...this.form,
        hotel_permissions: [
          {
            hotel_permissions_type: 'jin_jiang',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'long_teng',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'sui_chuan',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'li_cheng',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'ya_si_te',
            channel_price_rate: 0,
            is_enabled: 0,
          },
        ],
        is_open_company: 0,
        is_self_use: 0,
        book_rule_verify_enabled: 1,
        cancel_rule_verify_enabled: 1,
      }
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = Object.assign(
        {
          imgArray: [
            'http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png',
            'http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png',
          ],
        },
        row,
      ) // copy obj
      this.form.channel_commission_rate =
        this.form.channel_commission_rate * 100
      this.form.book_rule_verify_enabled = this.isRuleVerifyEnabled(
        this.form.book_rule_verify_enabled,
      )
        ? 1
        : 0
      this.form.cancel_rule_verify_enabled = this.isRuleVerifyEnabled(
        this.form.cancel_rule_verify_enabled,
      )
        ? 1
        : 0
      // this.form.channel_price_rate = this.form.channel_price_rate * 100
      console.log(this.form.hotel_permissions)

      if (
        !this.form.hotel_permissions ||
        this.form.hotel_permissions.length === 0
      ) {
        this.form.hotel_permissions = [
          {
            hotel_permissions_type: 'jin_jiang',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'long_teng',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'sui_chuan',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'li_cheng',
            channel_price_rate: 0,
            is_enabled: 0,
          },
          {
            hotel_permissions_type: 'ya_si_te',
            channel_price_rate: 0,
            is_enabled: 0,
          },
        ]
      } else {
        this.form.hotel_permissions = this.form.hotel_permissions.map(
          (item) => ({
            ...item,
            channel_price_rate: item.channel_price_rate * 100,
          }),
        )
        // 确保四种房源权限都存在
        const types = this.form.hotel_permissions.map(
          (item) => item.hotel_permissions_type,
        )
        if (!types.includes('sui_chuan')) {
          this.form.hotel_permissions.push({
            hotel_permissions_type: 'sui_chuan',
            channel_price_rate: 0,
            is_enabled: 0,
          })
        }
        if (!types.includes('li_cheng')) {
          this.form.hotel_permissions.push({
            hotel_permissions_type: 'li_cheng',
            channel_price_rate: 0,
            is_enabled: 0,
          })
        }
        if (!types.includes('ya_si_te')) {
          this.form.hotel_permissions.push({
            hotel_permissions_type: 'ya_si_te',
            channel_price_rate: 0,
            is_enabled: 0,
          })
        }
      }

      this.getChannelData(this.form.channel_id)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    // ============ 卡管理弹窗 ============
    /**
     * 房源权限标准化：保证 4 种类型齐全，且 channel_price_rate 转百分数
     * 后端返回的是小数（0.01 = 1%），表单内用百分数便于填写
     */
    normalizePermissions(list) {
      const stdTypes = ['jin_jiang', 'long_teng', 'sui_chuan', 'li_cheng']
      const src = Array.isArray(list) ? list : []
      // 先原样保留所有已有条目（含 ya_si_te 等标准 4 类之外的类型），避免保存时丢数据
      const out = src
        .filter(Boolean)
        .map((it) => ({
          ...it,
          channel_price_rate: Number(it.channel_price_rate || 0) * 100,
          is_enabled: Number(it.is_enabled || 0),
        }))
      // 再补齐缺失的标准 4 类
      stdTypes.forEach((t) => {
        if (!out.some((x) => x.hotel_permissions_type === t)) {
          out.push({
            hotel_permissions_type: t,
            channel_price_rate: 0,
            is_enabled: 0,
          })
        }
      })
      return out
    },
    openCardDialog(row) {
      if (!row) return
      this.cardDialogRow = row
      this.cardForm = {
        bind_api_accounts: Array.isArray(row.bind_api_accounts)
          ? row.bind_api_accounts.slice()
          : [],
        bind_api_cards: Array.isArray(row.bind_api_cards)
          ? row.bind_api_cards.slice()
          : [],
        hotel_permissions: this.normalizePermissions(row.hotel_permissions),
      }
      this.cardDialogVisible = true
    },
    saveCardDialog() {
      if (!this.cardDialogRow) return
      this.cardSaving = true
      // 以整行数据为基底提交，避免后端全量更新时因缺字段被拒（如 full_name 必填）
      const payload = JSON.parse(JSON.stringify(this.cardDialogRow))
      payload.bind_api_accounts = this.cardForm.bind_api_accounts
      payload.bind_api_cards = this.cardForm.bind_api_cards
      payload.hotel_permissions = this.cardForm.hotel_permissions.map((it) => ({
        ...it,
        channel_price_rate: Number(it.channel_price_rate || 0) / 100,
        is_enabled: Number(it.is_enabled || 0),
      }))
      request({
        url: '/api/backend/app-client/store',
        method: 'post',
        data: payload,
      })
        .then(() => {
          this.cardDialogVisible = false
          this.$notify({
            title: '成功',
            message: '卡管理已保存',
            type: 'success',
            duration: 2000,
          })
          this.getList()
        })
        .catch(() => {
          // 错误提示由请求拦截器统一弹出
        })
        .finally(() => {
          this.cardSaving = false
        })
    },
    /** 操作列「更多」下拉分发 */
    handleMoreCommand(command, row) {
      if (!row) return
      switch (command) {
        case 'disable':
          this.handleStatus(row.id, 0)
          break
        case 'enable':
          this.handleStatus(row.id, 1)
          break
        case 'commonInfo':
          this.handleUpdate1(row)
          break
        case 'initPassword':
          this.initPassword(row.id, 1)
          break
        default:
          break
      }
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          var form = JSON.parse(JSON.stringify(this.form))
          form.channel_commission_rate = form.channel_commission_rate / 100
          // form.channel_price_rate = form.channel_price_rate / 100
          form.hotel_permissions = form.hotel_permissions.map((item) => ({
            ...item,
            channel_price_rate: item.channel_price_rate / 100,
          }))
          request({
            url: '/api/backend/app-client/store',
            method: 'post',
            data: form,
          })
            .then((response) => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    handleUpdate1(row) {
      this.form1 = Object.assign({}, row.app_client_info) // copy obj
      this.form1.app_client_id = row.id
      this.dialogStatus1 = 'update'
      this.dialogFormVisible1 = true
      this.$nextTick(() => {
        this.$refs['form1'].clearValidate()
      })
    },
    saveData1() {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.btnLoading1 = true
          request({
            url: '/api/backend/app-client/store-info',
            method: 'post',
            data: this.form1,
          })
            .then((response) => {
              this.btnLoading1 = false
              this.dialogFormVisible1 = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading1 = false
            })
        }
      })
    },
    handleStatus(id, isNormal) {
      this.$confirm('此操作将修改客户端状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client/change-status',
            method: 'post',
            data: { id: id, is_normal: isNormal },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    initPassword(id) {
      this.$confirm('此操作将初始化客户端密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client/init-password',
            method: 'post',
            data: { id: id },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleChangeShowCost(row) {
      const newVal = row.is_show_cost == 1 ? 0 : 1
      const label = newVal === 1 ? '显示成本' : '不显示成本'
      this.$confirm(`确定将此客户端设为"${label}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client/change-show-cost',
            method: 'post',
            data: { id: row.id, is_show_cost: newVal },
          }).then(() => {
            row.is_show_cost = newVal
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

::v-deep(.el-form-item__content) {
  max-width: 400px;
}

/* ===== 客户列表 紧凑化（对齐客服系统的密度，不改框架） ===== */
::v-deep(.el-table) {
  /* 字号微调，保持可读 */
  font-size: 12px;

  th {
    padding: 6px 0;
    font-weight: 600;
    line-height: 1.4;
  }

  td {
    padding: 5px 0;
  }

  .cell {
    padding: 0 6px;
    line-height: 1.5;
    word-break: break-all;
  }

  /* 标签统一小尺寸、单行不换行 */
  .el-tag {
    height: 20px;
    line-height: 18px;
    padding: 0 5px;
    font-size: 11px;
  }
}

/* 操作列横排紧凑（参考客服系统风格；用 margin 而非 gap，兼容 webview） */
.ops-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  line-height: 1;

  > .el-button,
  > .el-dropdown {
    margin: 0 2px;
  }

  /* 抵消 el-button 相邻自动左外边距，避免与上面 margin 叠加 */
  > .el-dropdown .el-button,
  .el-button + .el-button {
    margin-left: 0;
  }

  /* 收窄按钮内边距，让 3 个控件稳居一行 */
  .el-button--mini {
    padding: 6px 8px;
    font-size: 12px;
  }
}

/* ===== 展开行：低频信息网格（每行 4 列） ===== */
.expand-detail {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 16px 6px;
  background: #fafbfd;
  border-radius: 6px;
}

.expand-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 25%;
  min-width: 0;
  padding: 4px 12px 4px 0;
}

.expand-label {
  flex: 0 0 auto;
  width: 104px;
  color: #909399;
  font-size: 12px;
}

.expand-value {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #303133;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;

  .el-button--text {
    font-size: 12px;
  }
}

/* 长文本列单行省略（避免 App ID 等换行撑高行） */
::v-deep(.cell-ellipsis .cell) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

/* 标签列单行展示（超出折叠为 +N，hover 看全部） */
.cell-tags {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;

  .el-tag {
    flex: 0 0 auto;
    margin-right: 3px;

    &:last-child {
      margin-right: 0;
    }
  }
}

/* ===== 卡管理弹窗 ===== */
.card-manage {
  &__target {
    margin-bottom: 14px;
    font-size: 13px;
    color: #606266;

    b {
      color: #303133;
    }
  }

  &__tip {
    color: #909399;
    font-size: 12px;
  }

  &__hint {
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.6;
    color: #909399;
  }

  /* 关键风险提示：用告警色，避免运营误判「不绑就不走丽呈」 */
  &__warn {
    display: inline-block;
    margin-top: 4px;
    color: #e6a23c;
  }

  &__perm {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  &__perm-label {
    margin: 0 10px 0 12px;
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
  }

  /* 卡管理弹窗内表单宽度放宽 */
  ::v-deep(.el-form-item__content) {
    max-width: 440px;
  }
}

.disabled-item {
  ::v-deep(.el-checkbox__label) {
    color: #f56c6c !important;
  }
}
</style>
